type AssistantApiAction = {
  target: string;
  method?: string;
};

const appRoutePrefixes = [
  "/dashboard",
  "/subscriptions",
  "/calendar",
  "/intelligence",
  "/analytics",
  "/scenarios",
  "/accounts",
  "/vision",
  "/settings",
  "/auth",
  "/future-stack",
];

const assistantEventAllowlist = new Set([
  "open-ai-chat",
  "open-command-palette",
  "open-notifications",
  "open-waitlist",
]);

const currentOrigin = () =>
  typeof window === "undefined" ? "http://localhost" : window.location.origin;

export const isSafeInternalRoute = (target: string) => {
  if (!target.startsWith("/") || target.startsWith("//") || target.includes("\\")) return false;
  try {
    const url = new URL(target, currentOrigin());
    if (url.origin !== currentOrigin()) return false;
    if (url.pathname === "/") return true;
    return appRoutePrefixes.some((prefix) => url.pathname === prefix || url.pathname.startsWith(`${prefix}/`));
  } catch {
    return false;
  }
};

export const isSafeAssistantEvent = (target: string) => assistantEventAllowlist.has(target);

export const isSafeAssistantApiTarget = (action: AssistantApiAction) => {
  if (!action.target.startsWith("/") || action.target.startsWith("//") || action.target.includes("\\")) return false;
  const method = (action.method || "POST").toUpperCase();
  if (action.target === "/subscriptions") return method === "POST";
  if (/^\/subscriptions\/[^/]+$/.test(action.target)) return ["PATCH", "DELETE"].includes(method);
  if (/^\/integrations\/[^/]+$/.test(action.target)) return ["PATCH", "DELETE"].includes(method);
  if (/^\/notifications\/[^/]+\/read$/.test(action.target)) return method === "PATCH";
  if (action.target === "/notifications/read-all") return method === "PATCH";
  if (action.target === "/settings") return method === "PATCH";
  if (action.target === "/decision-engine/usage-events") return method === "POST";
  if (action.target === "/decision-engine/recompute") return method === "POST";
  if (action.target === "/insight-actions") return method === "POST";
  if (/^\/future-subscriptions\/[^/]+$/.test(action.target)) return ["PATCH", "DELETE"].includes(method);
  if (action.target === "/future-subscriptions") return method === "POST";
  if (/^\/future-subscriptions\/[^/]+\/decision$/.test(action.target)) return method === "POST";
  if (/^\/future-subscriptions\/notifications\/[^/]+\/read$/.test(action.target)) return method === "PATCH";
  if (action.target === "/future-subscriptions/notifications/read-all") return method === "PATCH";
  return false;
};
